export default (app) => {
  if (!app.settings.debug) return;
  const channel = new BroadcastChannel("nystem-dev-events");
  const id = app.uuid();
  channel.onmessage = ({ data }) => {
    if (data.type !== "snapshot-request") return;
    channel.postMessage({
      type: "snapshot",
      request: data.request,
      id,
      url: location.pathname,
      contexts: app.addeventhandler.inspectEvents(app),
    });
  };
  if (import.meta.hot) import.meta.hot.dispose(() => channel.close());
  window.addEventListener("pagehide", () => channel.close(), { once: true });
};
